import script from "./DiscountForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscountForm.vue?vue&type=script&setup=true&lang=js"

import "./DiscountForm.vue?vue&type=style&index=0&id=1db8ed77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db8ed77"]])

export default __exports__